<div *ngIf="loadingData" class="alert alert-info"><strong><i class="la la-spinner la-spin"></i> Nalagam
  podatke</strong></div>
<ng-container *ngIf="!loadingData && (premium || createNew)">
  <form [formGroup]="form" novalidate (submit)="update(form)">
    <div class="form-group">
      <label for="title">Interno ime premium vsebine</label>
      <input type="text" class="form-control" id="title" formControlName="title">
    </div>

    <div class="d-flex justify-content-end">

      <div class="btn-group">
        <button type="button" class="button button-3d button-light button-small align-self-end dropdown-toggle"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="la la-plus"></i> Dodaj vsebinski blok
        </button>
        <div class="dropdown-menu" x-placement="bottom-start">
          <a class="dropdown-item" style="cursor: pointer" (click)="addBlock('generalContent')">Splošna vsebina</a>
          <a class="dropdown-item" style="cursor: pointer" (click)="addBlock('team')">Ekipa</a>
        </div>
      </div>
    </div>
    <accordion [isAnimated]="true" [formArrayName]="'content'"
               *ngFor="let item of form.get('content').controls; let i = index;"
               class="custom-accordion">
      <accordion-group
        [isOpen]="!forceClosed && ((openLast && i === form.get('content').controls.length - 1) || (!openLast && i === 0))">
        <h5 class="mb-0 d-flex justify-content-between" accordion-heading>
          <div class="align-self-center">
            <span class="float-left mr-3">{{item.value.title}}</span>
            <span class="badge badge-info text-white m-0">
              <ng-container [ngSwitch]="item.value.layout">
                <ng-container *ngSwitchCase="'team'">Ekipa</ng-container>
                <ng-container *ngSwitchCase="'generalContent'">Splošna vsebina</ng-container>
              </ng-container>
            </span>
          </div>
          <div class="btn-group btn-group-sm" (click)="$event.preventDefault();">
            <button class="btn btn-outline-dark" type="button" (click)="moveBlock(i, -1)"
                    *ngIf="i > 0"
                    [tooltip]="'Premakni vsebinski blok navzgor'"
            ><i
              class="la la-arrow-up"></i>
            </button>
            <button class="btn btn-outline-dark" type="button" (click)="moveBlock(i, 1)"
                    *ngIf="i < form.get('content').controls.length - 1"
                    [tooltip]="'Premakni vsebinski blok navzdol'">
              <i class="la la-arrow-down"></i>
            </button>
            <button class="btn btn-outline-danger" type="button" (click)="moveBlock(i, 0)"
                    [tooltip]="'Odstrani vsebinski blok'">
              <i class="la la-remove"></i>
            </button>
          </div>
        </h5>
        <div [formGroupName]="i">
          <input type="hidden" class="form-control form-control-sm" formControlName="layout">

          <div class="form-group">
            <label for="contTitle{{i}}">Naslov sekcije</label>
            <input type="text" class="form-control" id="contTitle{{i}}" formControlName="title">
          </div>

          <ng-container *ngIf="item.value.layout === 'generalContent'">

            <div class="form-group">
              <label>Prikaz sekcije</label><br/>
              <div class="custom-control custom-radio custom-control-inline pl-0">
                <input type="radio" id="customRadio11{{i}}" class="custom-control-input" formControlName="displayType"
                       value="left">
                <label class="custom-control-label" for="customRadio11{{i}}">Slika na levi</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="customRadio12{{i}}" class="custom-control-input" formControlName="displayType"
                       value="right">
                <label class="custom-control-label" for="customRadio12{{i}}">Slika na desni</label>
              </div>
            </div>

            <div class="form-group">
              <label for="title">Vsebina</label>
              <quill-editor formControlName="generalText" [styles]="{height: '250px'}"></quill-editor>
            </div>

            <div class="form-group">
              <label for="title">Slika</label>

              <ng-container *ngIf="item.value.newThumb">
                <div class="style-msg errormsg" *ngIf="item.value.newThumb.status === 'fail'">
                  <div class="sb-msg">
                    <i class="icon-thumbs-up"></i>
                    <strong>Napaka </strong>
                    pri nalaganju slike
                  </div>
                </div>

                <div class="image-upload" [ngClass]="{'image-upload-pending': item.value.newThumb.pending}">
                  <img *ngIf="item.value.newThumb.src" [src]="item.value.newThumb.src"
                       class="img-thumbnail">
                  <i class="la la-spinner la-spin"></i>
                </div>
              </ng-container>

              <ng-container *ngIf="item.value.thumb && !item.value.newThumb">
                <img [src]="item.value.thumb.url" class="img-thumbnail">
              </ng-container>

              <ng-container *ngIf="item.value.thumb">
                <div class="row">
                  <div class="col-6">
                    <div class="input-group">
                      <div class="custom-file">
                        <input #imageInput
                               type="file"
                               accept="image/*"
                               (change)="uploadImage(imageInput, false, item)"
                               style="width: 0"
                               class="custom-file-input" id="changeImageContent{{i}}"
                               aria-describedby="inputGroupFileAddon04">
                        <label class="button button-3d button-primary button-small ml-0 btn-block text-center"
                               for="changeImageContent{{i}}"><i class="la la-upload"></i> Zamenjaj sliko</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <button type="button" class="button button-3d button-pink button-small mr-0 btn-block text-center"
                            (click)="removeImage(item)">
                      <i class="la la-remove"></i> Odstrani sliko
                    </button>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="!item.value.thumb">
                <div class="input-group">
                  <div class="custom-file">
                    <input #imageInput
                           type="file"
                           accept="image/*"
                           (change)="uploadImage(imageInput, false, item)"
                           style="width: 0"
                           class="custom-file-input" id="addImage{{i}}"
                           aria-describedby="inputGroupFileAddon04">
                    <label class="button button-3d button-primary button-small m-0 btn-block text-center"
                           for="addImage{{i}}"><i class="la la-upload"></i> Naloži sliko</label>
                  </div>
                </div>
              </ng-container>
            </div>

          </ng-container>

          <ng-container *ngIf="item.value.layout === 'team'">

            <div class="form-group">
              <label>Prikaz sekcije</label><br/>
              <div class="custom-control custom-radio custom-control-inline pl-0">
                <input type="radio" id="customRadio1{{i}}" class="custom-control-input" formControlName="displayType"
                       value="3">
                <label class="custom-control-label" for="customRadio1{{i}}">3 v vrsto</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="customRadio2{{i}}" class="custom-control-input" formControlName="displayType"
                       value="5">
                <label class="custom-control-label" for="customRadio2{{i}}">5 v vrsto</label>
              </div>
            </div>

            <div *ngFor="let teamItem of item.get('team').controls; let j = index;"
                 [formArrayName]="'team'">
              <hr>
              <div [formGroupName]="j" class="row">
                <div class="col-3">
                  <div class="form-group d-flex flex-column justify-content-between pb-3" style="height: 100%">
                    <div>
                      <label for="title">Slika</label>

                      <ng-container *ngIf="teamItem.value.newThumb">
                        <div class="style-msg errormsg" *ngIf="teamItem.value.newThumb.status === 'fail'">
                          <div class="sb-msg">
                            <i class="icon-thumbs-up"></i>
                            <strong>Napaka </strong>
                            pri nalaganju slike
                          </div>
                        </div>

                        <div class="image-upload" [ngClass]="{'image-upload-pending': teamItem.value.newThumb.pending}">
                          <img *ngIf="teamItem.value.newThumb.src" [src]="teamItem.value.newThumb.src"
                               class="img-thumbnail">
                          <i class="la la-spinner la-spin"></i>
                        </div>
                      </ng-container>

                      <ng-container *ngIf="teamItem.value.thumb && !teamItem.value.newThumb">
                        <img [src]="teamItem.value.thumb.url" class="img-thumbnail">
                      </ng-container>

                      <ng-container *ngIf="teamItem.value.thumb">
                        <div class="input-group">
                          <div class="custom-file">
                            <input #imageInput
                                   type="file"
                                   accept="image/*"
                                   (change)="uploadImage(imageInput, teamItem, item)"
                                   style="width: 0"
                                   class="custom-file-input" id="changeImage{{i}}{{j}}"
                                   aria-describedby="inputGroupFileAddon04">
                            <label class="button button-3d button-primary button-small m-0 btn-block text-center"
                                   for="changeImage{{i}}{{j}}"><i class="la la-upload"></i> Zamenjaj sliko</label>
                          </div>
                        </div>

                        <button type="button"
                                class="button button-3d button-pink button-small m-0 btn-block text-center"
                                (click)="removeImage(teamItem)">
                          <i class="la la-remove"></i> Odstrani sliko
                        </button>
                      </ng-container>

                      <ng-container *ngIf="!teamItem.value.thumb">
                        <div class="input-group">
                          <div class="custom-file">
                            <input #imageInput
                                   type="file"
                                   accept="image/*"
                                   (change)="uploadImage(imageInput, teamItem, item)"
                                   style="width: 0"
                                   class="custom-file-input" id="addImage{{i}}{{j}}"
                                   aria-describedby="inputGroupFileAddon04">
                            <label class="button button-3d button-primary button-small m-0 btn-block text-center"
                                   for="addImage{{i}}{{j}}"><i class="la la-upload"></i> Naloži sliko</label>
                          </div>
                        </div>
                      </ng-container>
                    </div>

                    <div class="btn-group btn-group-sm" (click)="$event.preventDefault();">
                      <button class="btn btn-outline-dark" type="button" (click)="moveMember(i, j, -1)"
                              *ngIf="j > 0"
                              [tooltip]="'Premakni osebo navzgor'"
                      ><i
                        class="la la-arrow-up"></i>
                      </button>
                      <button class="btn btn-outline-dark" type="button" (click)="moveMember(i, j, 1)"
                              *ngIf="j < item.get('team').controls.length -1"
                              [tooltip]="'Premakni osebo navzdol'">
                        <i class="la la-arrow-down"></i>
                      </button>
                      <button class="btn btn-outline-danger" type="button" (click)="moveMember(i, j, 0)"
                              [tooltip]="'Odstrani osebo'">
                        <i class="la la-remove"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-9">
                  <div class="form-group">
                    <label for="title">Ime</label>
                    <input type="text" class="form-control form-control-sm" formControlName="name">
                  </div>

                  <div class="form-group">
                    <label for="title">Opis</label>
                    <quill-editor formControlName="description" [styles]="{height: '100px'}">
                      <div quill-editor-toolbar>
                        <span class="ql-formats">
                          <button class="ql-bold"></button>
                          <button class="ql-italic"></button>
                          <button class="ql-underline"></button>
                          <button class="ql-strike"></button>
                        </span>
                      </div>
                    </quill-editor>
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <div class="d-flex justify-content-end">
              <button class="button button-3d button-light button-small align-self-end" type="button"
                      (click)="addTeamMember(i)">
                <i class="la la-plus"></i> Dodaj osebo
              </button>
            </div>

          </ng-container>
        </div>
      </accordion-group>

    </accordion>

    <hr>
    <div class="d-flex justify-content-between">
      <div>
        <div class="style-msg successmsg" *ngIf="formSucces">
          <div class="sb-msg">
            <i class="icon-thumbs-up"></i>
            <strong>Bravo!</strong>
            {{formSucces}}
          </div>
        </div>
        <div class="style-msg errormsg" *ngIf="formError">
          <div class="sb-msg">
            <i class="icon-thumbs-up"></i>
            <strong>Napaka!</strong>
            {{formError}}
          </div>
        </div>
      </div>
      <button type="submit" class="button button-3d button-primary button-disabled" [disabled]="formProcessing">
        <i class="la la-check" *ngIf="!formProcessing"></i>
        <i class="la la-spinner la-spin" *ngIf="formProcessing"></i>
        <ng-container *ngIf="createNew">Shrani spremembe</ng-container>
        <ng-container *ngIf="!createNew">Shrani spremembe</ng-container>
      </button>
    </div>
  </form>
</ng-container>
